/* スライダー */
let mySwiper = new Swiper('.products_slider', {
    loop: false,
    loopedSlides: 3,
    slidesPerView: 1.5,
    spaceBetween: 40,
       navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    speed: 500,
    breakpoints: {
        768: {
          spaceBetween: 45,
            slidesPerView: 3,
        }
    }
});

    /* スライダー */
        let mySwiper2 = new Swiper('.highlights__slider', {
            loop: false,
            loopedSlides: 1,
            slidesPerView: 1,
            spaceBetween: 20,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: ".swiper-pagination", // ページネーションのクラス名を指定
                clickable: true
            },
            speed: 500,
            breakpoints: {
                768: {
                    spaceBetween: 45,
                    slidesPerView: 1,
                }
            }
        });

// スクロールヘッダー
$(function () {
  $(window).on('scroll', function () {
      const header = document.querySelector('.header');
      const fv = document.querySelector('.fv');
      const fvHeight = fv.offsetHeight;
    header.style.top = `${fvHeight}px` ;
      var headerH = $('.fv').outerHeight(true);
      var scroll = $(window).scrollTop();
      if (scroll >= headerH) {
          $('.header').addClass('active');
      } else {
          $('.header').removeClass('active');
      }
  });
});


